import formatNumber from './formatNumber'
import formatAmount from './formatAmount'
import formatPercent from './formatPercent'
import punctuation from './punctuation'

export default {
    formatNumber,
    formatAmount,
    formatPercent,
    punctuation,
}
